import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Styles from './styles.module.css';
import { ReactComponent as SocialYoutube } from '../../Assets/social/social-youtube.svg';
import { ReactComponent as SocialVimeo } from '../../Assets/social/social-vimeo.svg';
import { ReactComponent as SocialDevider } from '../../Assets/social/social-devider.svg';
import { ReactComponent as SocialFacebook } from '../../Assets/social/social-facebook.svg';
import { ReactComponent as SocialInstagram } from '../../Assets/social/social-instagram.svg';

export default class Contact extends Component {
    private apiKey = 'AIzaSyC4m3zeC4LspbqXhpYj-KJ93G7khj9mSws';

    render() {
        return (
            <>
                <Container fluid>
                    <Row className={Styles.container}>
                        <Col xs="12" md="12" lg="8">
                            <div className={Styles.contacts}>
                                <span style={{ width: '100%' }}>contact@minimalmovie.com</span> <br />
                                {/*<span>+380 50 368-7717</span> <br */}
                                {/* <span>+1 307 317-5559</span> */}
                                <div className={Styles.social}>
                                    <a href="https://www.youtube.com/channel/UC4eePO9PJu1zp2Z3FCg8uMw" target="_blank"><SocialYoutube /></a>
                                    <a href="https://vimeo.com/minimalmovie" target="_blank"><SocialVimeo /></a>
                                        <SocialDevider className={Styles.devider} />
                                    <a href="https://www.facebook.com/MinimalMovieProduction" target="_blank"><SocialFacebook /></a>
                                    <a href="https://www.instagram.com/minimalmovie/" target="_blank"><SocialInstagram /></a>
                                </div>
                            </div>
                        </Col>
                        {/*<Col xs="12" md="12" lg="4">
                            <iframe style={{ width: '100%', position:'relative', top:'50%', transform: 'translate(0, -50%)' }} height="360" id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2541.2389247818996!2d30.518097415904336!3d50.43665017947346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cefde5ba3ffd%3A0xfc494c086b026708!2sEsplanadna%20St%2C%2032%2C%20Kyiv%2C%2002000!5e0!3m2!1sen!2sua!4v1632995879277!5m2!1sen!2sua" frameBorder="0" scrolling="no" marginHeight={0} marginWidth={0}></iframe>
        </Col>*/}
                    </Row>
                </Container>
            </>
        )
    }
}